import { Text } from "@gravity-ui/uikit";
import { ReactNode } from "react";

import css from "./FormParamCard.module.scss";

interface FormParamCardProps {
  title: string;
  value?: ReactNode;
  endContent?: ReactNode;
}

export const FormParamCard = ({
  title,
  value,
  endContent,
}: FormParamCardProps) => {
  return (
    <div className={css.formParamCard}>
      <Text variant="body-1">{title}:</Text>
      {value && (
        <Text variant="subheader-2" style={{ width: "100%" }}>
          {value}
        </Text>
      )}
      {endContent}
    </div>
  );
};
